$(function () {

    DECIX.datepicker = DECIX.datepicker || {};

    DECIX.datepicker.init = function () {

        $(".datepicker").datepicker({
            todayBtn: "linked",
            todayHighlight: true,
            autoclose: true
        });

    };

    DECIX.datepicker.init();

});
